import { makeAutoObservable } from 'mobx'
import { toast } from 'react-toastify'
import { UserStore } from './UserStore'
import { api } from 'index'

class _AuthStore {
  isUserAuthenticated = false
  isPending = false

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true })
  }

  SET_USER_AUTHENTICATED = (isUserAuthenticated) => {
    this.isUserAuthenticated = isUserAuthenticated
  }

  SET_PENDING = (isPending) => {
    this.isPending = isPending
  }

  async login(email, password) {
    this.isPending = true

    try {
      const res = await api.auth.login({ email, password })

      localStorage.setItem('token', res.data)
      UserStore.updateUserData()
      this.isUserAuthenticated = true

      toast.success('Вы успешно авторизовались')
    } catch (e) {
      this.isUserAuthenticated = false

      toast.error(e.response?.data?.errors?.[0]?.message || 'Ошибка авторизации')

      return e
    } finally {
      this.isPending = false
    }
  }

  async logout() {
    try {
      await api.auth.logout()
      localStorage.removeItem('token')
      this.isUserAuthenticated = false
      toast.success('Вы успешно вышли из аккаунта')
      UserStore.clearUserData()
    } catch (e) {
      console.error(e)

      toast.error(e.message)
      return e
    }
  }

  async checkAuth(api) {
    this.isPending = true

    try {
      const res = await api.auth.refreshToken()

      localStorage.setItem('token', res.data)
      UserStore.updateUserData()
      this.isUserAuthenticated = true
    } catch (e) {
      console.error(e)

      if (localStorage.getItem('token')) {
        toast.error('Сессия истекла. Пожалуйста, авторизуйтесь')
        localStorage.removeItem('token')
      }

      this.isUserAuthenticated = false
    } finally {
      this.isPending = false
    }
  }
}

const AuthStore = new _AuthStore()

export { AuthStore }
